<template>
  <div class="modal-card">
    <header class="modal-card-head has-background-black-ter">
      <p class="modal-card-title has-text-light">
        <span v-if="!$store.getters['chartDate']">{{ $t('chart') }}</span>
        <span v-if="$store.getters['chartDate']">{{ $t('chart.imagery') }} {{ toDate($store.getters['chartDate']) }}</span>
      </p>
      <button
        @click="closeModal()"
        :title="$t('close')"
        class="delete is-medium">
      </button>
    </header>
    <section class="modal-card-body has-background-dark has-text-light">
      <chart-container-component
        v-if="!$store.getters['chartDate']"
        :parcel="parcel">
      </chart-container-component>
      <chart-imagery-component
        v-if="$store.getters['chartDate']"
        :parcel="parcel"
        :dates="ndviDates"
        :date="$store.getters['chartDate']">
      </chart-imagery-component>
    </section>
    <footer class="modal-card-foot has-background-black-ter has-text-light">
      <span v-if="!$store.getters['chartDate']">{{ $t('chart.footer.text') }}</span>
      <button
        v-if="$store.getters['chartDate']"
        class="button is-black"
        type="button"
        @click="clearChartDate()">
        {{ $t('view.chart') }}
      </button>
      <span>
        <button
          class="button is-black"
          type="button"
          @click="openFeedbackModal">
          {{ $t('feedback') }}
        </button>
      </span>
    </footer>
  </div>
</template>

<script>

import ChartContainerComponent from './ChartContainer'
import ChartImageryComponent from './ChartImagery'
import moment from 'moment'

export default {
  components: {
    ChartContainerComponent,
    ChartImageryComponent
  },
  props: {
    parcel: {
      type: Object,
      default: null
    },
    feedbackBtnClick: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      ndvi_idx: this.$conf.chart.lines.map(line => line.id).indexOf('ndvi_avg')
    }
  },
  computed: {
    ndviDates () {
      const dateColumn = this.$conf.chart.request[this.$conf.chart.lines[this.ndvi_idx].request].dateColumn
      return this.$store.getters['chartData'].data[this.ndvi_idx].map(row => this.toDate(row[dateColumn], 'YYYY-MM-DD'))
    }
  },
  mounted () {
    this.clearChartDate()
  },
  methods: {
    clearChartDate () {
      this.$store.dispatch('chartDate', null)
    },
    closeModal () {
      this.clearChartDate()
      this.$parent.close()
    },
    toDate (date, format = 'DD.MM') {
      return moment(date).format(format)
    },
    openFeedbackModal (e) {
      this.closeModal()
      this.feedbackBtnClick(e)
    }
  }
}
</script>

<style lang="stylus" scoped>
  .modal-card-body
    padding: 0
    position: relative
    height: calc(100vh - 180px)
    overflow: auto
  @media (min-width: 768px)
    .modal-card-body
      height: 420px
  @media (min-width: 1200px)
    .modal-card
      width: 1200px
</style>
